import {TealiumOptions} from './types';

export default (options: TealiumOptions) => ({
  channel: options.channel || 'Retail', // Channel in which the transaction is taking place, eg. "Retail", "Corporate" (GA CD9)
  site_name: options.siteName || 'austhealth.com.au', // Site Name or Identifier
  site_section: options.siteSection || 'IWHI Join', // The high-level sections of your site eg. Home, The Check Up, Health Insurance, Content, My Account etc.
  page_type: options.pageType || 'iwhi_quote_health', // Type of page eg. home, content
  page_name: options.pageName || 'your_page_name' // Tealium variable to identify the page name // project-level default, to be overwritten on each page
});
